import { useContext } from 'react'
import { I18nContext } from 'builder/context/I18nContext'

export const useI18n = () => useContext(I18nContext)
